import { IconWrapper } from '../runtime';
export default IconWrapper('fingernail', true, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 48 48",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M44 24C44 35.0457 35.0457 44 24 44C12.9543 44 4 35.0457 4 24C4 12.9543 12.9543 4 24 4",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin
    }
  }), h("path", {
    "attrs": {
      "d": "M38 9.47214L38.343 10.5279H39.4531L38.555 11.1803L38.8981 12.2361L38 11.5836L37.1019 12.2361L37.445 11.1803L36.5469 10.5279H37.657L38 9.47214Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth
    }
  }), h("rect", {
    "attrs": {
      "x": "18",
      "y": "13",
      "width": "12",
      "height": "24",
      "rx": "6",
      "fill": props.colors[1],
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin
    }
  }), h("path", {
    "attrs": {
      "d": "M18 25C16 25 13 27.1176 13 31C13 34.8824 13 38.8072 13 40.7842",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin
    }
  }), h("path", {
    "attrs": {
      "d": "M30 25C32 25 35 27.1176 35 31C35 34.8824 35 38.5229 35 40.5",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin
    }
  })]);
});